import { MutationTree, ActionTree, GetterTree } from 'vuex'
import { SET_STATUS } from '../types'
import { RootState } from '..'

export interface IBookingInfo {
    merchantId: string | undefined;
    data: string;
}

export interface IHoldBooking {
    merchantId: string;
    attribute: string;
    data: string;
    captcha: string;
    skipCaptcha: boolean;
}

export interface IHoldBookings {
    merchantId: string,
    attribute: string;
    data: string[]
    captcha?: string
}

export interface IHoldBookingData {
    facilityId: string;
    pax: number;
    date: string;
    timeStart?: string;
    timeEnd?: string;
    name: string;
    room: string;
    phone: string;
    email: string;
    channel: {
        type: string;
        name: string;
        description: string;
    };
}

export interface IBookingConfirmation {
    _id: string;
    facilityName: string;
    pax: number;
    date: string;
    timeStart: string;
    timeEnd: string;
    name: string;
    room: string;
    phone: string;
    email: string;
}

export interface IBookingState {
    status: string;
}

const state: IBookingState = {
    status: '',
}

const getters: GetterTree<IBookingState, RootState> = {
    status: (state) => state.status,
}

const mutations: MutationTree<IBookingState> = {
    [SET_STATUS](state, status) {
        state.status = status
    }
}

const actions: ActionTree<IBookingState, RootState> = {
    async loadStatus({ commit }, status: string) {
        return commit(SET_STATUS, status )
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}

